import { render, staticRenderFns } from "./OnboardingMatchingTransportsPage.vue?vue&type=template&id=43126b94&scoped=true&"
import script from "./OnboardingMatchingTransportsPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingTransportsPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingTransportsPage.vue?vue&type=style&index=0&id=43126b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43126b94",
  null
  
)

export default component.exports